module.exports = __webpack_public_path__ + "static/media/planting.4fe10d5f.jpg";